import { useQuery } from '@tanstack/react-query';
import { Heart } from 'lucide-react';
import { apiClient } from '@/shared/api/client';
import { RecipeCard } from '@/features/generate/components/RecipeCard';
import type { RecipeRecord } from '@/shared/types';

async function fetchFavorites(): Promise<RecipeRecord[]> {
  const response = await apiClient<{ data: RecipeRecord[] }>('/api/mixes/favorites');
  return response.data;
}

export function FavoritesTab(): JSX.Element {
  const { data, isLoading } = useQuery({
    queryKey: ['favorites'],
    queryFn: fetchFavorites,
  });

  if (isLoading) {
    return (
      <div className="flex h-40 items-center justify-center text-slate-500">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-slate-600 border-t-pink-500" />
      </div>
    );
  }

  const recipes = data?.flatMap((record) => record.response) ?? [];

  if (recipes.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 py-16 text-slate-500">
        <Heart className="h-10 w-10 opacity-50" />
        <p className="text-sm text-slate-700 dark:text-slate-300">В избранном пока пусто</p>
        <p className="max-w-xs text-center text-xs text-slate-600">
          Добавляйте понравившиеся рецепты из карточки генерации
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-100">Избранное</h2>
      {recipes.map((recipe, index) => (
        <RecipeCard key={recipe.id} recipe={recipe} index={index} />
      ))}
    </div>
  );
}
